import React from 'react'
import IconPng from 'atoms/IconPng'
import UnreadBadge from 'molecules/UnreadBadge'
import { NotifBtnContainer } from './styles'
import { connect } from 'react-redux'

const icons = {
  ic_notif: require('App/assets/images/ic_notif.png'),
  ic_notif_s: require('App/assets/images/ic_notif_s.png')
}

const NotifBtn = ({ notifications, fnShowNotif }) => {
  const unreadCount = notifications.filter(notif => notif.readAt === null)
  return (
    <NotifBtnContainer onClick={fnShowNotif}>
      <IconPng
        srcIcon={unreadCount.length > 0 ? icons.ic_notif_s : icons.ic_notif}
        size={'auto'}
        h={'17'}
        showPointer={true} />
      {unreadCount.length > 0 &&
        <UnreadBadge count={unreadCount.length} />
      }
    </NotifBtnContainer>
  )
}

const mapStateToProps = state => {
  return {
    notifications: state.notifications
  };
};

export default connect(
  mapStateToProps,
  null
)(NotifBtn)
